module.exports = __webpack_public_path__ + "frontend/images/miles/screen-payments-xs-aba108268e987ab76248347ac0ea157d.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/screen-payments-xs.png
// module id = 326
// module chunks = 2